import { ITypedReduxAction } from '../../../types/redux/actionType';
import { TPostCard } from '../../../types/postCard';

export enum EGetPostCardActionType {
  Loading = 'postCard/getPostCard/loading',
  Succeed = 'postCard/getPostCard/succeed',
  Failed = 'postCard/getPostCard/failed',
}

export type TGetPostCardLoading = ITypedReduxAction<EGetPostCardActionType.Loading>;
export type TGetPostCardSucceed = ITypedReduxAction<EGetPostCardActionType.Succeed, TPostCard>;
export type TGetPostCardFailed = ITypedReduxAction<EGetPostCardActionType.Failed>;

export type TGetPostCard = TGetPostCardLoading | TGetPostCardSucceed | TGetPostCardFailed;
